import { Injectable } from '@angular/core';
import { ServerConnectService } from '@app/core/services/server-connect.service';
import { ApiTypes, MessageConfig } from '@app/shared/constants/constant';
import { ApiConfig } from '@app/shared/constants/url-constant';
import { ForgotPassword, Login, Signup } from '../authentication.model';
import firebase from 'firebase/compat/app';
import { UntypedFormGroup } from '@angular/forms';
import { UtilService } from '@app/core/services/util.service';
import { Router } from '@angular/router';
import { queryParams } from '@app/shared/utils/query-params';
import { AppUpdateService } from '@app/core/services/app-update.service';

@Injectable({
  providedIn: 'root',
})
export class SigninService {
  public token: any;
  public userVerified: any;
  public type = ApiTypes;
  public userUid: any;
  public emailVerify: boolean;
  public otpId: number;
  constructor(
    private serverConnectService: ServerConnectService,
    private utilService: UtilService,
    public router: Router,
    private appUpdateService: AppUpdateService
  ) { }
  public siginInEmail(loginData: Login) {
    return firebase.auth().signInWithEmailAndPassword(
      loginData.email,
      loginData.password
    );
  }
  public authetication(login) {
    this.utilService.showSpinnerLoader();
    this.siginInEmail(login)
      .then((auth: any) => {
        Promise.resolve(firebase.auth().currentUser)
          .then((res: any) => {
            try {
              if (!res.emailVerified) {
                this.emailVerify = true;
                this.utilService.dismissLoader();
                this.utilService.showToastCtrl(MessageConfig.emailverify);
              }
              else {
                this.appUpdateService.urlSetCompletedLoginError.next(true);
              }
            } catch (error) {
            }
          })
          .catch((afError) => {
            this.utilService.dismissLoader();
          });
      })
      .catch((error) => {
        this.utilService.dismissLoader();
                // Handle errors
                switch (error.code) {
                  case 'auth/user-not-found':
                  case 'auth/wrong-password':
                  case 'auth/invalid-login-credentials':
                  case 'auth/internal-error':
                    this.utilService.errorAlert(MessageConfig.LoginErrorTitle,MessageConfig.WrongLoginAlert);
                    break;
                    case 'auth/network-request-failed':
                    this.utilService.showToastCtrlMessage(MessageConfig.wifiIcon + MessageConfig.offlineAlert);
                    break;
                  default:
                    this.utilService.showToastCtrlMessage(MessageConfig.wrongAlert);
                    break;
                }
      });
  }
  public checkFlag(uid: string) {
    return new Promise((resolve) => {
      const userStatusRef = firebase.database().ref('/Userprofilesetup/' + uid);
      userStatusRef.once('value', (snapshot) => {
        // setTimeout(() => {
          if (snapshot.val() != null) {
            resolve(
              snapshot.val().Flag ? snapshot.val().Flag : snapshot.val().flag
            );
          } else {
            resolve(false);
          }
        // }, 100);
      }, () => {
        resolve(false);
      });
    });
  }

  // Send email verfificaiton when new user sign up
  public sendEmailVerification(username: string) {
    const databody = 'Email=' + username;
    this.serverConnectService.connectToServer(
      this.type.POST,
      ApiConfig.EmailVerification,
      databody,
      false,
      false,
      false
    );
  }

  public signupEmail(signupData: Signup) {
    return firebase.auth().createUserWithEmailAndPassword(
      signupData.Email,
      signupData.Password
    );
  }
 public checkEmailExists(email: string): Promise<boolean> {
    return firebase.auth()
      .fetchSignInMethodsForEmail(email)
      .then((signInMethods) => {
        return signInMethods && signInMethods.length > 0;
      })
      .catch((error) => {
        return false;
      });
      // APID-5590 | Purpose of this code: To check Wheather User Email already exists or not in our firebase
      // Before Signing Up.
  }

  public async setProfileFlag(uid?: string) {
    const userUid = uid ?? firebase.auth().currentUser?.uid;
    if (userUid) {
      this.userUid = userUid;
      const reference = firebase
        .database()
        .ref('/Userprofilesetup/' + this.userUid);
      reference.set({
        flag: '0',
      });
    }
  }
  public saveSingupDetails(signupData, uid?: string) {
    return new Promise((resolve, reject) => {
      const useruid = uid ?? firebase.auth().currentUser?.uid;
      if (!useruid) {
        reject(new Error('Firebase user not available after signup.'));
        return;
      }
      const databody =
        'UID=' +
        useruid +
        '&Role=' +
        signupData.Role +
        '&data=' +
        JSON.stringify(signupData);
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.signupUrl,
          databody,
          false,
          false,
          false
        )
        .then((res) => {
          resolve('successful');
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  public sendOnForgetMail(forgetpassword: ForgotPassword) {
    return new Promise((resolve, reject) => {
      const databody = 'Email=' + forgetpassword.UserName;
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.ForgetPasswordMail,
          databody,
          false,
          false,
          false
        )
        .then((data) => {
          if (data) {
            resolve(true);
            this.router.navigate(['/signin']);
            this.utilService.showToastCtrl(MessageConfig.PasswordReset);
          } else {
            resolve(false);
            this.utilService.showToastCtrl(MessageConfig.PasswordDetected);
          }
        });
    });
  }
  public sendlogin() {
    const databody = queryParams({
      deviceToken: this.utilService.deviceToken,
      registrationType: this.utilService.registrationType,
    });
    return new Promise((resolve) => {
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.apiLogin,
          databody,
          false,
          false,
          false
        )
        .then((res: any) => {
          return resolve(res);
        });
    });
  }
  public sendContactNumberForOTP(contactNumber: any) {

    const databody = queryParams({
      user_contact_number: contactNumber
    });
    return new Promise((resolve) => {
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.optVerification,
          databody,
          false,
          false,
          false
        )
        .then((res: any) => {
          this.otpId = res.otpid;
          return resolve(res);
        });
    });
  }

  public verifyCode(code: number | null): Promise<boolean> {
    const databody = queryParams({
      otpid: this.otpId,
      code,
      action: 'verify'
    });
    return new Promise<boolean>((resolve) => {
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.optVerification,
          databody,
          false,
          false,
          false
        )
        .then((res: any) => {
          return res == 'verified' ? resolve(true) : resolve(false);
        });
    });
  }

  public sendEmailForOTP(oldEmail: string, newEmail: string): Promise<any> {
    const databody = queryParams({
      old_email: oldEmail,
      new_email: newEmail
    });
    return new Promise((resolve, reject) => {
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.emailOtpVerification,
          databody,
          false,
          false,
          false
        )
        .then((res: any) => {
          if (res && res['0'] === 'This EmailID Already Exists') {
            reject('EMAIL_EXISTS');
          } else {
            resolve(res);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public verifyEmailCode(code: number, oldEmail: string, newEmail: string) {
    const databody = queryParams({
      // otpid: this.otpId,
      code,
      action: 'verify',
      old_email: oldEmail,
      new_email: newEmail
    });
    return new Promise((resolve) => {
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.emailOtpVerification,
          databody,
          false,
          false,
          false
        )
        .then((res: any) => {
          return res?.message === 'Email verified successfully' ? resolve(true) : resolve(false);
        });
    });
  }

  public async reauthenticateUser(currentEmail: string): Promise<boolean> {
    try {
      const user = firebase.auth().currentUser;
      if (!user) return false;
      const password = await this.promptForPassword();
      if (!password) return false;
      const credential = firebase.auth.EmailAuthProvider.credential(
        currentEmail,
        password
      );
      await user.reauthenticateWithCredential(credential);
      return true;
    } catch (error) {
      return false;
    }
  }

  private async promptForPassword(): Promise<string> {
    return new Promise<string>((resolve) => {
      const password = prompt('Please enter your current password to continue');
      resolve(password || '');
    });
  }

  public async updateEmailInFirebase(newEmail: string): Promise<boolean> {
    try {
      const user = firebase.auth().currentUser;
      if (user) {
        await user.updateEmail(newEmail);
        const uid = user.uid;
        const userProfileRef = firebase.database().ref(`/Userprofilesetup/${uid}`);
        const snapshot = await userProfileRef.once('value');
        const profileData = snapshot.val();
        if (profileData) {
          const updatedProfile = {
            ...profileData,
            email: newEmail
          };
          await userProfileRef.set(updatedProfile);
        }
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }

  public sendLogout() {
    const databody = queryParams({
      deviceToken: this.utilService.deviceToken,
      registrationType: this.utilService.registrationType,
    });
    return new Promise((resolve,reject) => {
      this.serverConnectService
        .connectToServer(
          this.type.POST,
          ApiConfig.deleteDeviceToken,
          databody,
          false,
          false,
          false
        )
        .then((res: any) => {
          resolve(res);
        }).catch((err)=>{
          reject(err)
          this.utilService.dismissLoader();
        });
    });
  }
}
